module.exports = __webpack_public_path__ + "static/media/ico_cross.988eb4d4.svg";